module.exports = __webpack_public_path__ + "media/images/country_flags/lc-012f962ad28c1959b02b33d38a6ace10.png";